'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearUnseenCountForChannel = undefined;

var _reduxActions = require('redux-actions');

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var _getThreadByChannel = require('../../threads/selectors/getThreadByChannel');

var _calculateUnseenThreadsCount = require('../../threads/selectors/calculateUnseenThreadsCount');

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _postUnreadConversationCountChangedEvent = require('../../threads/actions/postUnreadConversationCountChangedEvent');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var clearUnseenCountForChannelAction = (0, _reduxActions.createAction)(ActionTypes.CLEAR_UNSEEN_COUNT_FOR_CHANNEL);

var clearUnseenCountForChannel = exports.clearUnseenCountForChannel = function clearUnseenCountForChannel(_ref) {
  var channel = _ref.channel;
  return function (dispatch, getState) {
    var thread = (0, _getThreadByChannel.getThreadByChannel)(getState(), { channel: channel });

    var unseenCountForThread = (0, _threadGetters.getUnseenCount)(thread);

    if (unseenCountForThread > 0) {
      dispatch(clearUnseenCountForChannelAction({ channel: channel }));

      var newUnreadThreadsCount = (0, _calculateUnseenThreadsCount.calculateUnseenThreadsCount)(getState());

      dispatch((0, _postUnreadConversationCountChangedEvent.postUnreadConversationCountChangedEvent)({
        unreadCount: newUnreadThreadsCount
      }));
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/actions/ConversationsActions/clearUnseenCountForChannel.js
// module id = 430
// module chunks = 2 3